import React from "react"
import { httpClient } from "../../helper/utils"
import { Constant } from "../../helper/constant"
import { formatDateTransaction } from "../../helper/formatDate"

/**
 * @typedef {Object} RefundByStaffPayload
 * @property {string} staff_id
 * @property {string} [page]
 * @property {string} [start_date]
 * @property {string} [end_date]
 */

/**
 * @param {RefundByStaffPayload} payload
 */
async function getRefundByStaffId(payload) {
  const params = new URLSearchParams()
  params.append("page", payload.page)

  if (payload.staff_id) {
    params.append("staff_id", payload.staff_id)
  }

  if (payload.start_date || payload.end_date) {
    params.append("start_date", formatDateTransaction(payload.start_date, "daily"))
    params.append("end_date", formatDateTransaction(payload.end_date, "daily"))
  }

  const token = localStorage.getItem("token")
  const response = await httpClient(
    `${Constant.BASE_API_URL}/produk-transaksi/refund-data?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.json();
}

/**
 * @param {RefundByStaffPayload} payload 
 */
export function useRefundByStaff(payload) {
  const [data, setData] = React.useState([])
  const [page, setPage] = React.useState(1)
  const [totalPage, setTotalPage] = React.useState(1)
  const [isLoading, setIsLoading] = React.useState(false)
  const [isError, setIsError] = React.useState(false)

  React.useEffect(() => {
    setPage(1)
  }, [payload])

  React.useEffect(() => {
    async function fetchData() {
      setIsLoading(true)
      setIsError(false)
      try {
        const result = await getRefundByStaffId({
          ...payload,
          page: page,
        })
        setData(result?.data?.refund_data ?? [])
        setTotalPage(result?.data?.pagination.total_pages ?? 1)
      } catch (error) {
        setData([])
        setIsError(true)
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [payload, page])

  const nextPage = React.useCallback(() => {
    setPage((prevPage) => Math.min(prevPage + 1, totalPage))
  }, [totalPage])

  const previousPage = React.useCallback(() => {
    setPage((prevPage) => Math.max(prevPage - 1, 1))
  }, [])

  const isNextPageActive = page < totalPage
  const isPreviousPageActive = page > 1

  // React.useEffect(() => {
  //   console.log('next-page ', Math.min(page + 1, totalPage))
  //   console.log('previous-page ', Math.max(page - 1, 1))
  // }, [page, totalPage])

  return {
    data,
    page,
    totalPage,
    isLoading,
    isError,
    isNextPageActive,
    isPreviousPageActive,
    nextPage,
    previousPage,
  }
}
